// Catch-all 404. Big destructive-red number, short message, home link.

import { Button, H1, P } from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
})

function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-6 py-16 text-center">
      <p className="m-0 text-8xl font-bold leading-none text-destructive">404</p>
      <H1 className="mt-4">Страницата не е намерена</H1>
      <P className="mt-2 text-muted-foreground">
        Страницата, която търсите, не съществува или е била преместена.
      </P>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Button asChild>
          <a href="/">Към началната страница</a>
        </Button>
        <Button asChild variant="outline">
          <a href="/reports">Архив на отчети</a>
        </Button>
      </div>
    </div>
  )
}
